/**
 * The wire envelope — docs/ARCHITECTURE.md §8.1. Defined once here and imported
 * by both apps/api and apps/web so the two can never drift.
 */
export function isApiError(value) {
    return (typeof value === 'object' &&
        value !== null &&
        'error' in value &&
        typeof value.error === 'object' &&
        value.error !== null &&
        typeof value.error.code === 'string');
}
export const MAX_PAGE_SIZE = 100;
export const DEFAULT_PAGE_SIZE = 25;
/**
 * Upper bound on `page`. **Ours, not vendor-documented** — the upstream gives
 * no guidance. Without it `?page=99999999999` answers 200 and forces an
 * unbounded `OFFSET` on every list route (QA defect D-04).
 */
export const MAX_PAGE = 10_000;
//# sourceMappingURL=http.js.map